// FilterContext.js
import React, { createContext, useState, useContext } from 'react';

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
    const [showFeedbackOnly, setShowFeedbackOnly] = useState(false);

    return (
        <FilterContext.Provider value={{ showFeedbackOnly, setShowFeedbackOnly }}>
            {children}
        </FilterContext.Provider>
    );
};

export const useFilter = () => useContext(FilterContext);